  <!--  会员统计 -->
<template>
    <div class="statistics-module">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedRegion.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup"
                    class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedStore.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
            </div>
            <div class="title-tab-box" v-if="dimension==3">
                <van-tabs animated v-model="activeName" @change="clickTypeTab">
                    <van-tab title="看生美" name="sm"> </van-tab>
                    <van-tab title="看抗衰" name="ks"> </van-tab>
                </van-tabs>
            </div>
            <div class="statistics-box flex-between flex">
                <div class="members-data-box flex-col">
                    <span v-if="postId==1||postId=='1472787652026765367'|| regionPostId.includes(postId)"
                        class="members-describe">{{dimension==3&&activeName=='ks'?'抗衰会员总数':dimension==3&&activeName=='sm'?'生美会员总数':'本店总会员数'}}</span>
                    <span v-else class="members-describe">专属会员数</span>
                    <span class="members-number">{{this.storageAssetsList.totalCustNum}}人</span>
                </div>
                <div class="members-data-box flex-col flex-y-bottom">
                    <div class="statistics-date  flex-1">数据截止{{this.storageAssetsList.dataDeadline}}</div>
                    <div class="select-box flex flex-y-center flex-start"
                        v-if="postId != '2' && postId != 42 && postId != '1472787652026765441'">
                        <div class="select-item mr-50 flex-between flex-y-center" @click="selectEmployeePopup">
                            <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                            <van-icon name="play" class="select-arrow" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="head-chart">
                <div ref="headchart" id="headchart"></div>
            </div>
            <div
                :class="['chart-description','flex-wrap','flex-y-center',dimension==1?'flex-start':dimension==2?'flex-between':dimension==3?'flex-between':'']">
                <div :class="['flex-y-center',,dimension==3?'description-box-ks':'description-box']"
                    v-for="item,index in chartTypeList" :key="index">
                    <div class="type-color" :style="{'background':item.color}"></div>
                    <span class="type-name">{{item.name}}</span>
                </div>
            </div>

            <div class="interval"></div>
            <div class="members-details-box flex-y-center">
                <div v-if="dimension==1"
                    :class="`member-type-icon ${checkedType.id== 1?'v3-color':(checkedType.id== 2?'high-color':checkedType.id== 3?'potential-color':checkedType.id== 0?'all-color':checkedType.id== 5?'vip-color':'basic-color')}`">
                </div>
                <div v-else-if="dimension==2" class="member-type-icon"
                    :style="{ background: checkedType.id ==1 ? '#2FD0D5' : checkedType.id== 2 ?'#F56C40':checkedType.id== 3?'#A8BCFE':checkedType.id== 4?'#5678FF':checkedType.id== 5?'#AC5D5D':checkedType.id== 6?'#F9B59F':'#a0acb5'}">
                </div>
                <div class="select-item flex flex-between flex-y-center" @click="selectTypePopup">
                    <div class="select-tit">{{checkedType && checkedType.name}}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
            </div>
            <div class="consumption-screening flex-y-center">
                <div class="search-num flex-1">
                    <form action="javascript:return true">
                        <div>
                            {{dimension == 1||(dimension == 3&&activeName=='sm')?'集团':dimension == 2?'医美':dimension == 3&&activeName=='ks'?'抗衰':''}}消费大于<input
                                type="number" v-model="propertyAmount" @keyup.13="onAmountSearch" placeholder="自定义"
                                class="num-input" /> 万</div>
                    </form>
                </div>
                <div class="sort-select flex-between flex-y-center" @click="selectSortPopup">
                    <div class="sort-select-tit">{{ checkedSort && checkedSort.name }}</div>
                    <van-icon name="play" class="sort-select-arrow" />
                </div>
            </div>
            <div class="list-box">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDetail" :offset="20"
                    :immediate-check="false">
                    <div class="customer-list flex" v-for="item,index in memberStatisticsList" :key="index"
                        @click="toDetail(item.custId,item.custMobile)">
                        <img class="customer-head-portrait" referrerpolicy="no-referrer" alt=""
                            :src="item.avatar?item.avatar:'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                        <div class="customer_info flex-col flex-1">
                            <div class="flex-y-center">
                                <span class="customer-name">{{item.custName}}</span>
                                <img v-if="item.cardLevelImg" class="levelCodeImg" referrerpolicy="no-referrer" alt=""
                                    :src="item.cardLevelImg" />
                            </div>
                            <span class="consumption"> R12{{dimension!=2?'集团':'医美'}}消费：{{item.groupConsume}}万</span>
                            <span class="consumption" v-if="dimension==3">R12抗衰消费：{{item.groupKangShuaiAmount}}万</span>
                            <span class="arrival-times"
                                v-if="dimension!=3">R12{{dimension==1?'集团':'医美'}}到店次数：{{item.groupToStore}}次</span>
                            <span class="arrival-times" v-if="dimension==3">R12抗衰到诊次数：{{item.kangShuaiStoreCount}}次</span>
                            <span class="arrival-times" v-if="dimension==3">R12生美到店次数：{{item.shengMeiStoreCount}}次</span>
                            <span class="arrival-times"
                                v-if="dimension!=3">最近{{dimension==1?'到店':'到诊'}}时间：{{item.toStoreTime}}</span>
                            <span class="arrival-times" v-if="dimension==3">最近抗衰到诊时间：{{item.toKsStoreTime}}</span>
                            <span class="arrival-times" v-if="dimension==3">最近生美到店时间：{{item.toSmStoreTime}}</span>
                        </div>
                        <img class="arrow_right" referrerpolicy="no-referrer" alt=""
                            src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                    </div>
                </van-list>
            </div>
        </van-pull-refresh>
        <van-popup v-model="showTypePopup" round position="bottom" closeable class="popup">
            <picker title="会员类型" @handle="checkedType" v-model="checkedType" :list="typeList" @change="onTypeChange">
            </picker>
        </van-popup>
        <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup">
            <picker title="排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
        </van-popup>
        <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup">
            <picker :title="employeePopupTitle" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange">
            </picker>
        </van-popup>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
    </div>
</template>


<script>
import request from "@/utils/request";
import Picker from '@/components/Picker';
import { Toast } from "vant";
import { getCookie } from '@/utils'
import { mapState } from 'vuex'
import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

const SORT_LIST = [{ name: '集团消费降序', id: 1 }, { name: '集团消费升序', id: 2 }]
const SORT_LIST_YM = [{ name: '医美消费降序', id: 1 }, { name: '医美消费升序', id: 2 }]
const SORT_LIST_KS = [{ name: '抗衰消费降序', id: 1 }, { name: '抗衰消费升序', id: 2 }, { name: '生美到店次数降序', id: 3 }]
export default {
    inject: ['reload'],
    name: "memberStatistics",
    components: {
        Picker
    },
    data() {
        return {
            showTypePopup: false, //会员类型
            typeList: [],    //会员类型列表
            checkedType: {}, //会员类型
            showSortPopup: false, // 排序
            propertyAmount: '',  // 集团消费
            type: 0,   //统计类型
            storageAssetsList: {},   //饼图统计数据
            memberStatisticsList: [],
            page: 1,       // 当前页
            limit: 10,       // 每页多少条
            total: 0,     // 列表总条数
            loading: false,    // 加载
            finished: false,    // 结束加载
            refreshing: false,   //刷新
            postId: 0, // 岗位
            showRegionPopup: false,
            showRegionStorePopup: false,
            regionStoreList: [],//区域门店列表
            regionList: [],//区域列表
            checkedRegion: { id: -1, name: '' },//所选区域
            checkedStore: {  //所选门店
                name: '',
                id: -1,
            },
            dimension: 0, //区分生美医美 1 生美 2 医美 3 抗衰
            sortList: [{ name: '集团消费降序', id: 1 }, { name: '集团消费升序', id: 2 }],//排序opt
            checkedSort: {},//排序
            showEmployeePopup: false,// 选择员工弹窗
            employeeList: [], // 员工
            checkedEmployee: null,//所选员工
            employeePopupTitle: '',
            radius: 1, // 生美/抗衰切换
            activeName: "store", //tab

        };
    },
    computed: {
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
        checkedSortCompu() {
            if (this.dimension == 1) {
                return SORT_LIST[0]
            } else if (this.dimension == 2) {
                return SORT_LIST_YM[0]
            } else if (this.dimension == 3) {
                return SORT_LIST_KS[0]
            }
        },
        chartTypeList() { // 图表圆点
            if (this.dimension == 1) {
                return [
                    {
                        name: 'VVIP ：>10W',
                        color: "#2fd0d5"
                    },
                    {
                        name: 'V3 ：6.5W-10W',
                        color: "#f56c40"
                    },
                    {
                        name: '优质客 ：3W-6.5W',
                        color: "#f9b59f"
                    },
                    {
                        name: '高潜力 ：1W-3W',
                        color: "#5678ff"
                    },
                    {
                        name: '基础客 ：≤1W',
                        color: "#a8bcfe"
                    },
                ]
            } else if (this.dimension == 2) {
                return [
                    {
                        name: 'VIP：≥10W',
                        color: "#2fd0d5"
                    },
                    {
                        name: '去年VIP：≥10W',
                        color: "#AC5D5D"
                    },
                    {
                        name: '今年VIP：≥10W',
                        color: "#F9B59F"
                    },
                    {
                        name: '高消费：4.7W-10W',
                        color: "#F56C40"
                    },
                    {
                        name: '中消费：1.7W-4.7W',
                        color: "#A8BCFE"
                    },
                    {
                        name: '低消费：＜1.7W',
                        color: "#5678FF"
                    }
                ]
            } else if (this.dimension == 3) {
                return [
                    {
                        name: 'VVIP ：>10W',
                        color: "#5678FF"
                    },
                    {
                        name: 'V3 ：6.5W-10W',
                        color: "#72D8DB"
                    },
                    {
                        name: '优质客 ：3W-6.5W',
                        color: "#A8BCFE"
                    },
                    {
                        name: '高潜力 ：1W-3W',
                        color: "#F56C40"
                    },
                    {
                        name: '基础客 ：≤1W',
                        color: "#F9B59F"
                    },
                    {
                        name: '',
                        color: ""
                    },
                ]
            }
        }
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension //生美1 医美2
        this.employeePopupTitle = this.dimension == 1 ? '全部员工' : this.dimension == 2 ? '主诊人' : this.dimension == 3 ? '健康顾问' : '' // 选择器标题
        this.sortList = this.dimension == 1 ? SORT_LIST : this.dimension == 2 ? SORT_LIST_YM : this.dimension == 3 ? SORT_LIST_KS : []
        this.checkedSort = this.dimension == 1 ? SORT_LIST[0] : this.dimension == 2 ? SORT_LIST_YM[0] : this.dimension == 3 ? SORT_LIST_KS[0] : {}
        if (this.$route.query.type) {
            this.type = this.$route.query.type;
        } else {
            this.type = 1
        }
        // 获取当前登陆人所记录的区域门店信息
        getUserLogin().then((res) => {
            if (this.regionPostId.includes(this.postId)) {
                this.checkedRegion.name = res.data.region?.storeName // 当前区域
                this.checkedRegion.id = res.data.region?.id
                if (res.data.store) {
                    this.checkedStore.name = res.data.store.storeName //当前门店
                    this.checkedStore.id = res.data.store.id
                    // 门店列表
                    let params = {
                        id: this.checkedRegion.id
                    }
                    getRegionStoreList(params).then((res) => {
                        this.regionStoreList = res.data
                    })
                }
                // 区域列表
                getRegionStoreList().then((res) => {
                    this.regionList = res.data
                })
                // 如果当前没有选择门店记录，则进入大区页面
                if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                    this.$router.replace({
                        name: "memberStatisticsRegionPage"
                    });
                }
            }
            this.init();
        })
    },
    watch:
    {
        type(value) {
            this.$nextTick(() => {
                // this.page = 1;
                // this.getDetail();
            })
        }
    },

    methods: {
        async init() {
            await this.getEmpList()
            this.getStatistics();
        },
        //资产饼图加载
        onLoad() {
            let data = []
            if (this.dimension == 1) {
                data = [
                    { value: this.storageAssetsList.threeCustNum, name: '{c|V3 \n' + this.storageAssetsList.threeCustNum + '人 \n' + this.storageAssetsList.threeCustRate + '%}', itemStyle: { color: '#f56d41' } },
                    { value: this.storageAssetsList.gaoJiaZhiCustNum, name: '{c|优质客 \n' + this.storageAssetsList.gaoJiaZhiCustNum + '人 \n' + this.storageAssetsList.gaoJiaZhiCustRate + '%}', itemStyle: { color: '#f9b59f' } },
                    { value: this.storageAssetsList.qianLiKeCustNum, name: '{c|高潜力 \n' + this.storageAssetsList.qianLiKeCustNum + '人 \n' + this.storageAssetsList.qianLiKeCustRate + '%}', itemStyle: { color: '#5778ff' } },
                    { value: this.storageAssetsList.jiChuKeCustNum, name: '{c|基础客 \n' + this.storageAssetsList.jiChuKeCustNum + '人 \n' + this.storageAssetsList.jiChuKeCustRate + '%}', itemStyle: { color: '#a8bdfe' } },
                    { value: this.storageAssetsList.vvipNum, name: '{c|VVIP \n' + this.storageAssetsList.vvipNum + '人 \n' + this.storageAssetsList.vvipRate + '%}', itemStyle: { color: '#2FD0D5' } },
                ]
            } else if (this.dimension == 2) {
                data = [
                    { value: this.storageAssetsList.vipNum, name: '{c|VIP \n' + this.storageAssetsList.vipNum + '人 \n' + this.storageAssetsList.vipRate + '%}', itemStyle: { color: '#72D8DB' } },
                    { value: this.storageAssetsList.highNum, name: '{c|高消费 \n' + this.storageAssetsList.highNum + '人 \n' + this.storageAssetsList.highRate + '%}', itemStyle: { color: '#F56C40' } },
                    { value: this.storageAssetsList.centreNum, name: '{c|中消费 \n' + this.storageAssetsList.centreNum + '人 \n' + this.storageAssetsList.centreRate + '%}', itemStyle: { color: '#A8BCFE' } },
                    { value: this.storageAssetsList.lowNum, name: '{c|低消费 \n' + this.storageAssetsList.lowNum + '人 \n' + this.storageAssetsList.lowRate + '%}', itemStyle: { color: '#5678FF' } },
                    { value: this.storageAssetsList.lastYearNum, name: '{c|去年VIP \n' + this.storageAssetsList.lastYearNum + '人 \n' + this.storageAssetsList.lastYearRate + '%}', itemStyle: { color: '#AC5D5D' } },
                    { value: this.storageAssetsList.thisYearNum, name: '{c|今年VIP \n' + this.storageAssetsList.thisYearNum + '人 \n' + this.storageAssetsList.thisYearRate + '%}', itemStyle: { color: '#FBB7A0' } },
                ]
            } else if (this.dimension == 3) {
                data = [
                    { value: this.storageAssetsList.threeCustNum, name: '{c|' + this.storageAssetsList.threeCustRate + '% V3 \n' + this.storageAssetsList.threeCustNum + '人 \n}', itemStyle: { color: '#72D8DB' } },
                    { value: this.storageAssetsList.gaoJiaZhiCustNum, name: '{c|' + this.storageAssetsList.gaoJiaZhiCustRate + '% 优质客 \n' + this.storageAssetsList.gaoJiaZhiCustNum + '人 \n}', itemStyle: { color: '#A8BCFE' } },
                    { value: this.storageAssetsList.qianLiKeCustNum, name: '{c|' + this.storageAssetsList.qianLiKeCustRate + '% 高潜力 \n' + this.storageAssetsList.qianLiKeCustNum + '人 \n}', itemStyle: { color: '#F56C40' } },
                    { value: this.storageAssetsList.jiChuKeCustNum, name: '{c|基础客 ' + this.storageAssetsList.jiChuKeCustRate + '% \n' + this.storageAssetsList.jiChuKeCustNum + '人 \n}', itemStyle: { color: '#F9B59F' } },
                    { value: this.storageAssetsList.vvipNum, name: '{c|VVIP ' + this.storageAssetsList.vvipRate + '% \n' + this.storageAssetsList.vvipNum + '人 \n}', itemStyle: { color: '#5678FF' } },
                ]
            }
            const _this = this
            // 基于准备好的dom，初始化echarts实例
            let myEcharts = this.$echarts.init(this.$refs.headchart);
            window.onresize = myEcharts.resize;
            let options = {
                series: [
                    {
                        type: 'pie',
                        // center: ['50%', '50%'],
                        radius: ['32%', '54%'],
                        // avoidLabelOverlap: false,  //备注隐藏
                        label: {
                            show: true,
                            rich: {
                                c: {
                                    padding: [6, 0, 0, 0],
                                    fontSize: window.innerWidth * 26 / 750,
                                    color: "#35434C",
                                    align: 'left',
                                },
                            },
                        },
                        labelLine:
                        {
                            normal: {
                                length: 30,
                                length2: 25,
                                lineStyle: {
                                    width: 2//设置线条粗细
                                }
                            }
                        },
                        data: data
                    }
                ]
            };
            myEcharts.setOption(options);
            // 默认高亮一个
            let chooseIndex = this.type - 1;
            // highlight:突出
            myEcharts.dispatchAction({ type: 'highlight', seriesIndex: 0, dataIndex: chooseIndex });
            myEcharts.off('click');//双图表场景下先清除上个图表点击事件
            myEcharts.on('click', function (param) { //添加点击事件
                if (param.dataIndex != chooseIndex)   //生美产品
                {
                    myEcharts.dispatchAction({ type: 'downplay', seriesIndex: 0, dataIndex: chooseIndex });
                }
                chooseIndex = param.dataIndex;
                console.log(chooseIndex);

                myEcharts.dispatchAction({ type: 'highlight', seriesIndex: 0, dataIndex: param.dataIndex });
                _this.type = param.dataIndex + 1;
                _this.checkedType = _this.typeList[param.dataIndex + 1];
                _this.page = 1;
                _this.memberStatisticsList = [];
                _this.getDetail();
            });
        },
        //会员统计
        getStatistics() {
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
                className: 'toast',
            });
            let params = {
                empId: this.checkedEmployee && this.checkedEmployee.id,
                radius: this.radius
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            return request({
                url: '/debt/getStoreCustTotalInfo',
                method: "get",
                params: params
            }).then((res) => {
                this.storageAssetsList = res.data;
                this.onLoad();
                this.getTypeList();
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 获取员工列表
        getEmpList() {
            return request({
                url: "/sys/params/selectByStoreTreasure",
                method: "get",
                params: {
                    storeId: this.checkedStore.id,
                    id: this.checkedStore.id
                }
            })
                .then((res) => {
                    this.employeeList = res.data
                    this.checkedEmployee = this.employeeList[0] //默认全部

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },

        // 获取会员列表
        getDetail() {
            this.loading = true;
            this.finished = false;
            let params = {
                sortType: this.checkedSort.id,
                groupConsume: this.propertyAmount,
                limit: 10,
                page: this.page,
                type: this.checkedType.id,
                empId: this.checkedEmployee && this.checkedEmployee.id,
                radius: this.radius
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: `/debt/getStoreCustTotalInfoList`,
                method: "get",
                params: params
            })
                .then((res) => {
                    this.memberStatisticsList = this.page == 1 ? res.data.list : this.memberStatisticsList.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    // 手动清除 Toast
                    Toast.clear();
                    // this.refreshing = false;
                    if (this.memberStatisticsList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },

        //会员类型选择
        selectTypePopup() {
            this.showTypePopup = true;
        },
        // 获取会员类型列表
        getTypeList() {
            let params = {
                empId: this.checkedEmployee && this.checkedEmployee.id,
                radius: this.radius
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: "/debt/getCustContactTypeInfo",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.typeList = res.data
                    this.checkedType = this.typeList[this.type] //默认全部

                    this.getDetail();
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        //会员类型筛选
        onTypeChange(data) {
            this.checkedType = data;
            this.showTypePopup = false;
            this.page = 1;
            this.getDetail();
        },

        //显示排序筛选
        selectSortPopup() {
            this.showSortPopup = true
        },
        //排序筛选
        onSortChange(data) {
            this.showSortPopup = false;
            this.checkedSort = data;
            this.page = 1;
            this.getDetail();
        },
        //刷新
        onRefresh() {
            this.page = 1
            this.finished = false;
            this.refreshing = false;
            this.memberStatisticsList = [];
            this.getStatistics();
        },
        //查看顾客详情
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },
        //集团消费搜索
        onAmountSearch() {
            this.page = 1
            this.getDetail();
            document.activeElement.blur();//关闭手机软键盘
        },
        // 筛选区域门店相关
        openRegionPopup() {
            this.showRegionPopup = true
        },
        onRegionChange(data) {
            this.checkedRegion = data
            this.showRegionPopup = false
            this.$nextTick(() => {
                // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                this.checkedStore.id = 0
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then((res) => {
                    this.$router.replace({
                        name: "memberStatisticsRegionPage"
                    });

                })
            })
        },
        openRegionStorePopup() {
            this.showRegionStorePopup = true
        },
        onRegionStoreChange(data) {
            this.checkedStore = data
            this.showRegionStorePopup = false
            let params = {
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id
            }
            saveRegionStore(params).then(() => {
                if (data.id == 0 || data.id == -1) {
                    this.$router.replace({
                        name: "memberStatisticsRegionPage"
                    });
                } else {
                    this.reload();
                }
            })
        },
        // 选择员工
        selectEmployeePopup() {
            this.showEmployeePopup = true
        },
        onEmployeeChange(data) {
            this.checkedEmployee = data
            this.showEmployeePopup = false
            console.log(this.checkedEmployee && this.checkedEmployee.id);
            this.onRefresh()
        },
        //查看类型切换
        clickTypeTab() {
            if (this.activeName == "sm") {
                this.radius = 1;
            }
            else {
                this.radius = 3;
            }
            this.onRefresh();
        },
    },
};
</script>

<style scoped  lang="less">
.van-loading {
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
}
.statistics-module {
    height: 100%;
    padding: 0 0 40px 0;
    overflow-y: auto;
}
.store-box {
    padding: 30px 30px 0 30px;
    background-color: #fff;
    .store-arrow {
        width: 16px;
        height: 26px;
        margin-left: 8px;
        margin-top: 3px;
    }
    .region-name-box {
        min-width: 239px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        margin-right: 10px;
        padding: 10px 15px 11px 16px;
    }
    .store-name-box {
        min-width: 187px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        padding: 10px 15px 11px 16px;
    }
    .name-txt {
        color: #66757f;
        font-size: 26px;
    }
}
.statistics-box {
    padding: 20px 30px 0 30px;
    .members-data-box {
        width: 45%;
    }
    .select-box {
        .select-tit {
            font-size: 28px;
            color: #35434c;
        }
        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }
    .members-describe {
        width: 100%;
        height: 42px;
        font-size: 30px;
        color: #35434c;
        line-height: 42px;
    }
    .members-number {
        min-width: 105px;
        height: 50px;
        font-size: 36px;
        font-weight: 700;
        color: #35434c;
        line-height: 50px;
        margin-top: 20px;
    }
    .statistics-date {
        min-width: 256px;
        height: 37px;
        font-size: 26px;
        color: #a0acb5;
        line-height: 37px;
        text-align: right;
    }
}
.head-chart {
    // padding-top: 60px;
    #headchart {
        height: 536px;
    }
}

.chart-description {
    padding: 10px 30px 14px 30px;
    .description-box {
        margin-right: 40px;
        margin-bottom: 14px;
    }
    .description-box-ks {
        width: 224px;
        margin-bottom: 14px;
    }
    .type-color {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        // margin-top: -5px;
    }
    .type-name {
        // width: 109px;
        height: 28px;
        font-size: 20px;
        color: #66757f;
        margin-left: 10px;
    }
    .ml26 {
        margin-left: 26px;
    }
}
.chart-description.pb-30 {
    padding-bottom: 30px;
}

.vip-color {
    background: #2fd0d5;
}
.v3-color {
    background: #f56c40;
}
.high-color {
    background: #f9b59f;
}
.potential-color {
    background: #5678ff;
}
.basic-color {
    background: #a8bcfe;
}
.all-color {
    background: #a0acb5;
}
.interval {
    height: 20px;
    background: #f9fafc;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0);
}
.members-details-box {
    padding: 40px 30px 0 30px;
    .member-type-icon {
        border-radius: 50%;
        width: 16px;
        height: 16px;
        margin-right: 10px;
    }
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 28px;
        margin-left: 20px;
    }
    .select-item {
    }
}

.consumption-screening {
    padding: 40px 30px;
    .search-num {
        // height: 40px;
        font-size: 28px;
        color: #35434c;
        // line-height: 40px;
        .num-input {
            width: 148px;
            height: 60px;
            background: #f3f5f6;
            border-radius: 6px;
            border: none;
            margin: 0 10px;
            text-align: center;
        }
    }

    .sort-select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .sort-select-arrow {
        transform: rotate(90deg);
        font-size: 28px;
        margin-left: 20px;
    }
}

.list-box {
    padding: 0 30px 10px 30px;
    .customer-list {
        padding: 30px 30px;
        width: 690px;
        min-height: 196px;
        background: #fafafe;
        border-radius: 20px;
        margin-bottom: 20px;
    }
    .customer-head-portrait {
        width: 90px;
        height: 90px;
        border-radius: 45px;
    }
    .customer_info {
        padding: 0 20px;
    }
    .customer-name {
        // height: 42px;
        font-size: 30px;
        font-weight: 700;
        color: #35434c;
        line-height: 42px;
    }
    .consumption {
        // height: 40px;
        font-size: 28px;
        color: #a0acb5;
        line-height: 40px;
        margin-top: 6px;
    }
    .arrival-times {
        // height: 40px;
        font-size: 28px;
        color: #a0acb5;
        line-height: 40px;
        margin-top: 6px;
    }
    .arrow_right {
        width: 15px;
        height: 26px;
        margin-top: 8px;
    }
    .levelCodeImg {
        width: 58px;
        height: 34px;
        margin-left: 20px;
    }
}
:deep(.van-toast) {
    background: rgba(195, 33, 33, 0.4) !important ;
}
:deep(.van-toast.van-toast--fail, .van-toast.van-toast--loading) {
    background: #a0acb5 !important ;
    width: 30px !important ;
    min-height: 30px !important ;
}
.title-tab-box {
    padding: 30px 90px 0 90px;
    :deep(.van-tabs__nav--line) {
        display: flex;
        justify-content: space-between;
    }
    :deep(.van-tabs__line) {
        display: none;
    }
    :deep(.van-tab) {
        // flex: none !important;
        flex: 0 0 45% !important;
        // width: 250px;
        padding: 0 !important;
        height: 70px !important;
        line-height: 70px !important;
        color: #35434c;
        font-size: 30px;
    }
    :deep(.van-tab.van-tab--active) {
        height: 70px !important;
        line-height: 70px;
        background: #2fd0d5 !important;
        border-radius: 35px !important;
        box-shadow: 4px 10px 30px 0px rgba(55, 219, 224, 0.2) !important;
        color: #fff !important;
        font-weight: 400;
    }
}
</style>
